import React, { useState } from 'react';
import { Button, FormDatePicker, FormSubmitButton, MasterDetailForm, Widget, notification } from '@digital/ui';
import { Modal, Row, Tooltip } from 'antd';
import * as Yup from 'yup';
import { useRecoilState, useRecoilValue } from 'recoil';
import { ordemCompraIdState, reloadVendorListState, reloadWidgetTimelineState, dataLimiteEtapaState } from '../atoms';
import { iniciarPropostaComercial } from '@app/api/sas/sasProposta';
import { Visibility } from '@app/components';

interface Props {
    disabled?: boolean;
}

export const ButtonIniciarPropostaComercial = (props: Props) => {
    const { disabled } = props;
    const ordemCompraId = useRecoilValue(ordemCompraIdState);
    const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);
    const [reloadWidgetTimeline, setReloadWidgetTimeline] = useRecoilState(reloadWidgetTimelineState);
    const dataLimiteEtapa = useRecoilValue(dataLimiteEtapaState);
    const [open, setOpen] = useState(false);

    const onSubmit = (values: any) => {
        iniciarPropostaComercial(ordemCompraId, values.dataLimite)
            .then((response: any) => {
                if (response && response.valid !== false) {
                    setReloadVendorList(!reloadVendorList);
                    setReloadWidgetTimeline(!reloadWidgetTimeline);
                    setOpen(false);
                }
            })
            .catch(() => {
                notification.error('Erro ao iniciar proposta comercial.');
            });
    };

    return (
        <>
            <Tooltip title="Notificar fornecedores da Proposta Comercial">
                <Button
                    type="primary"
                    onClick={() => setOpen(true)}
                    disabled={disabled}
                >
                    Notificar fornecedores da Proposta Comercial
                </Button>
            </Tooltip>
            <Visibility visible={open}>
                <Modal
                    title="Notificar fornecedores da Proposta Comercial"
                    width="680px"
                    visible={open}
                    onCancel={() => setOpen(false)}
                    footer={null}
                >
                    <MasterDetailForm
                        initialValues={{ dataLimite: undefined }}
                        validationSchema={Yup.object().shape({
                            dataLimite: Yup.string().nullable().required('Data limite é obrigatória'),
                        })}
                        actions={[
                            <Button key="cancelarBtn" type="link" onClick={() => setOpen(false)}>
                                Cancelar
                            </Button>,
                            <FormSubmitButton key="enviarBtn" title="Iniciar" noIcon type="primary" onClick={onSubmit} />,
                        ]}
                    >
                        <Widget>
                            <Row>
                                <FormDatePicker
                                    label="Data Limite de Resposta"
                                    name="dataLimite"
                                    format="DD/MM/YYYY"
                                    span={4}
                                    disabledDate={function(current) {
                                        if (!dataLimiteEtapa) return false;
                                        var limite = new Date(dataLimiteEtapa);
                                        limite.setHours(23, 59, 59, 999);
                                        return current && current.toDate() > limite;
                                    }}
                                />
                            </Row>
                            <Row>
                                <p style={{ textAlign: 'center', paddingTop: '20px', paddingBottom: '20px' }}>
                                    Deseja iniciar a etapa de proposta comercial para todos os fornecedores ativos?
                                </p>
                            </Row>
                        </Widget>
                    </MasterDetailForm>
                </Modal>
            </Visibility>
        </>
    );
};

export default ButtonIniciarPropostaComercial;
